import React, { useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import MyTextInput from '../../app/common/form/MyTextInput'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import agent from '../../app/api/agent'
import AuthShell from '../../app/common/ui/AuthShell'
import { AppButton, AppStack, AppText } from '../../app/common/ui'

export default function ResetPasswordForm () {
  const location = useLocation()
  const history = useHistory()
  const params = new URLSearchParams(location.search)
  const userId = params.get('userId')
  const token = params.get('token')
  const [apiError, setApiError] = useState<string | null>(null)

  if (!userId || !token) {
    return (
      <AuthShell title="INVALID RESET LINK">
        <AppStack spacing="sm">
          <AppText size="sm" color="red" align="center">
            Invalid reset link. Please request a new one from the forgot password page.
          </AppText>
          <AppButton variant="light" onClick={() => history.push('/forgot-password')}>
            Request new link
          </AppButton>
        </AppStack>
      </AuthShell>
    )
  }

  return (
    <AuthShell title="RESET PASSWORD">
      <Formik
        initialValues={{ newPassword: '', confirmPassword: '' }}
        validationSchema={Yup.object({
          newPassword: Yup.string().required().min(6, 'Password must be at least 6 characters'),
          confirmPassword: Yup.string().required().oneOf([Yup.ref('newPassword')], 'Passwords must match')
        })}
        onSubmit={async (values) => {
          setApiError(null)
          try {
            await agent.Account.resetPassword(userId, token, values.newPassword, values.confirmPassword)
            toast.success('Password reset successfully.')
            history.push('/login')
          } catch (e: any) {
            const detail = e?.response?.data?.detail
            setApiError(typeof detail === 'string' ? detail : 'Failed to reset password. The link may have expired.')
          }
        }}
      >
        {({ handleSubmit, isSubmitting, isValid, dirty }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            <AppStack spacing="sm">
              <MyTextInput name="newPassword" placeholder="New password" type="password" label="New password" />
              <MyTextInput name="confirmPassword" placeholder="Confirm password" type="password" label="Confirm password" />
              {apiError && (
                <AppText size="sm" color="red">
                  {apiError}
                </AppText>
              )}
              <AppButton type="submit" disabled={!isValid || !dirty || isSubmitting} loading={isSubmitting} fullWidth>
                Reset password
              </AppButton>
            </AppStack>
          </form>
        )}
      </Formik>
    </AuthShell>
  )
}
